import type { ReportsMessageId } from "./reports.fr";

/** Signalements in European Portuguese. Same keys and {placeholders} as reports.fr.ts. */
export const reportsPt: Record<ReportsMessageId, string> = {
  "reports.filter.severity": "Gravidade",
  "reports.filter.status": "Estado",
  "reports.filter.all": "Todos",
  "reports.filter.reviewOverdue": "Revisão de suspensão em atraso",
  "reports.list.loading": "A carregar as denúncias…",
  "reports.list.loadFailed": "Não foi possível carregar as denúncias.",
  "reports.list.empty": "Nenhuma denúncia para estes filtros.",
  "reports.list.aria": "Denúncias",
  "reports.list.by": "denunciado por {name}",
  "reports.list.aboutSubject": "{count} denúncias sobre esta pessoa",
  "reports.pick": "Escolha uma denúncia na lista.",
  "reports.loading": "A carregar a denúncia…",
  "reports.loadFailed": "Não foi possível carregar esta denúncia.",
  "reports.notFound": "Esta denúncia não foi encontrada. Recarregue a lista.",
  "reports.refreshFailed": "Não foi possível atualizar a denúncia: é mostrada tal como estava.",
  "reports.dismiss": "Fechar",

  "reports.severity.critical": "Crítica",
  "reports.severity.high": "Alta",
  "reports.severity.medium": "Média",
  "reports.severity.low": "Baixa",
  "reports.status.open": "Aberta",
  "reports.status.investigating": "Em investigação",
  "reports.status.decided": "Decidida",
  "reports.status.appealed": "Em recurso",
  "reports.status.closed": "Encerrada",
  "reports.verdict.none": "Sem sanção",
  "reports.verdict.warning": "Advertência",
  "reports.verdict.temporary_suspension": "Suspensão temporária",
  "reports.verdict.permanent_ban": "Banimento definitivo",
  "reports.appeal.upheld": "Decisão mantida",
  "reports.appeal.overturned": "Decisão anulada",
  "reports.source.app": "Pela aplicação",
  "reports.source.phone": "Por telefone",
  "reports.source.console": "Aberta pela equipa",

  "reports.category.assault": "Agressão",

  "reports.new.title": "Nova denúncia",

  "reports.new.source": "Como chegou até nós",

  "reports.new.byPhone": "Por telefone",

  "reports.new.byStaff": "Notado pela equipa",

  "reports.new.subject": "Quem está a ser denunciado",

  "reports.new.reporter": "Quem fez a denúncia",

  "reports.new.reporterHint": "O identificador, se foi um cliente. Deixe vazio se foi a equipa a notar.",

  "reports.new.category": "O que aconteceu",

  "reports.new.categoryHint": "A gravidade decorre disto. Pode alterar depois.",

  "reports.new.description": "O que nos foi dito",

  "reports.new.descriptionHint": "Nas palavras da pessoa, sempre que possível. É o que lê quem investiga.",

  "reports.new.submit": "Abrir a denúncia",

  "reports.new.needSubject": "Escolha quem está a ser denunciado.",

  "reports.new.needDescription": "Descreva o que aconteceu, pelo menos numa frase.",

  "reports.new": "Nova denúncia",
  "reports.category.sexual_violence": "Violência sexual",
  "reports.category.serious_theft": "Roubo grave",
  "reports.category.weapon_threat": "Ameaça com arma",
  "reports.category.theft": "Roubo",
  "reports.category.threats": "Ameaças",
  "reports.category.harassment": "Assédio",
  "reports.category.fraud": "Burla",
  "reports.category.unsafe_work": "Trabalho perigoso",
  "reports.category.no_show": "Falta à marcação",
  "reports.category.other": "Outro",

  "reports.pill.suspended": "Suspenso",
  "reports.pill.reviewOverdue": "Revisão em atraso",
  "reports.pill.legalHold": "Retenção legal",

  "reports.detail.versionTitle": "A versão da denúncia mostrada: cada ação envia-a.",
  "reports.detail.critical": "Denúncia crítica",
  "reports.detail.needsPolice": "Ainda não foi transmitida à polícia. Os proprietários foram avisados.",
  "reports.detail.subject": "Pessoa denunciada",
  "reports.detail.reporter": "Autor da denúncia",
  "reports.detail.openedBy": "Aberta por {name}",
  "reports.detail.noReporter": "Desconhecido",
  "reports.detail.job": "Pedido associado",
  "reports.detail.case": "Processo de origem",
  "reports.detail.subjectCase": "Processo da pessoa denunciada",
  "reports.detail.openCase": "Abrir o processo →",
  "reports.detail.noSubjectCase": "Nenhum: abre-se com a suspensão ou o recurso",
  "reports.detail.none": "Nenhum",
  "reports.detail.description": "O que aconteceu",
  "reports.detail.restrictions": "Suspensões e banimentos",
  "reports.detail.restrictionsHint":
    "Uma suspensão dura até uma decisão da equipa. O prazo de revisão não é um fim: passado esse prazo, a pessoa continua suspensa e a revisão fica em atraso.",
  "reports.detail.verdict": "Veredicto",
  "reports.detail.decidedBy": "Por {name}, a {date}",
  "reports.detail.appeal": "Recurso",
  "reports.detail.appealedAt": "Recurso recebido a {date}",
  "reports.detail.appealPending": "Por decidir",
  "reports.detail.police": "Transmissões à polícia",
  "reports.detail.shared": "Dados entregues: {categories} · {name}, {date}",
  "reports.detail.holds": "Retenções legais",
  "reports.detail.holdPlaced": "Em vigor desde {date} · {name}",
  "reports.detail.holdReleased": "Levantada a {date} · {name}",
  "reports.detail.related": "Outras denúncias sobre esta pessoa",
  "reports.detail.timeline": "Cronologia",
  "reports.detail.actions": "Ações",
  "reports.detail.noActions": "Nenhuma ação possível com as suas funções nesta denúncia.",

  "reports.restriction.interim_suspension": "Suspensão durante a investigação",
  "reports.restriction.temporary_suspension": "Suspensão temporária",
  "reports.restriction.permanent_ban": "Banimento definitivo",
  "reports.restriction.untilDecision": "Até decisão da equipa",
  "reports.restriction.untilDecisionReviewBy": "Até decisão da equipa · a rever antes de {date}",
  "reports.restriction.until": "Até {date}",
  "reports.restriction.permanent": "Definitivo, salvo recurso aceite",
  "reports.restriction.switchedOff": "Desligado: {features}",
  "reports.restriction.lifted": "Levantada a {date} por {name}",
  "reports.restriction.inForce": "Em vigor",
  "reports.restriction.ended": "Terminada",

  "reports.entry.report": "Denúncia",
  "reports.entry.evidence": "Prova",
  "reports.entry.severity_changed": "Gravidade alterada",
  "reports.entry.suspended": "Suspensão",
  "reports.entry.suspension_lifted": "Suspensão levantada",
  "reports.entry.verdict": "Veredicto",
  "reports.entry.appeal": "Recurso",
  "reports.entry.appeal_decided": "Recurso decidido",
  "reports.entry.police_referral": "Transmitida à polícia",
  "reports.entry.police_data_shared": "Dados entregues à polícia",
  "reports.entry.legal_hold_placed": "Retenção legal aplicada",
  "reports.entry.legal_hold_released": "Retenção legal levantada",
  "reports.entry.linked": "Ligação adicionada",
  "reports.entry.suspension_withheld": "Suspensão não aplicada",
  "reports.entry.system": "Sistema",
  "reports.entry.evidenceLink": "Ver a prova →",

  "reports.police.category.identity": "Identidade",
  "reports.police.category.contact_details": "Contactos",
  "reports.police.category.id_document": "Documento de identificação",
  "reports.police.category.messages": "Mensagens",
  "reports.police.category.job_details": "Detalhes do pedido",
  "reports.police.category.report_and_evidence": "Denúncia e provas",
  "reports.police.category.audit_log": "Registo de auditoria",
  "reports.police.category.payments": "Pagamentos",
  "reports.hold.entity.safety_report": "Esta denúncia",
  "reports.hold.entity.user": "A conta",
  "reports.hold.entity.job": "O pedido",
  "reports.hold.entity.conversation": "A conversa",

  "reports.block.ownVerdict": "O veredicto foi proferido por si: outra pessoa tem de decidir o recurso.",
  "reports.block.ownerOnly": "Só um proprietário pode entregar dados à polícia.",
  "reports.block.noReferral": "Transmita primeiro a denúncia à polícia para registar os dados entregues.",

  "reports.action.evidence": "Adicionar uma prova",
  "reports.action.severity": "Alterar a gravidade",
  "reports.action.suspend": "Suspender durante a investigação",
  "reports.action.lift": "Levantar a suspensão",
  "reports.action.verdict": "Proferir o veredicto",
  "reports.action.ban": "Banir definitivamente",
  "reports.action.appeal": "Decidir o recurso",
  "reports.action.police": "Transmitir à polícia",
  "reports.action.share": "Registar dados entregues",
  "reports.action.hold": "Aplicar uma retenção legal",
  "reports.action.release": "Levantar a retenção legal",

  "reports.dialog.evidence.title": "Adicionar uma prova · {reference}",
  "reports.dialog.evidence.body":
    "Descreva a prova e, se estiver online, indique a ligação. Passa a constar da cronologia.",
  "reports.dialog.severity.title": "Alterar a gravidade · {reference}",
  "reports.dialog.severity.body":
    "Uma denúncia crítica avisa os proprietários e tem de ser transmitida à polícia. Indique porque altera.",
  "reports.dialog.suspend.title": "Suspender · {reference}",
  "reports.dialog.suspend.body":
    "{name} deixa de poder usar a Walliyo, exceto para contactar a equipa e recorrer, até uma decisão da equipa. Aplica-se um prazo de revisão: não é um fim da suspensão. A pessoa é avisada na aplicação e abre-se um processo em seu nome.",
  "reports.dialog.lift.title": "Levantar a suspensão · {reference}",
  "reports.dialog.lift.body": "{name} recupera o acesso à Walliyo a partir de agora. Indique porquê.",
  "reports.dialog.verdict.title": "Proferir o veredicto · {reference}",
  "reports.dialog.verdict.body":
    "O motivo é lido por {name} na aplicação, com a possibilidade de recorrer uma vez. Ninguém é sancionado sem motivo escrito.",
  "reports.dialog.ban.title": "Banir definitivamente · {reference}",
  "reports.dialog.ban.body":
    "{name} perde o acesso à Walliyo de vez, e o documento de identificação é banido. O motivo é-lhe mostrado na aplicação; pode recorrer uma vez.",
  "reports.dialog.appeal.title": "Decidir o recurso · {reference}",
  "reports.dialog.appeal.body":
    "Anulada levanta o que o veredicto aplicou. {name} lê o seu motivo na aplicação. Tem de decidir alguém que não o autor do veredicto.",
  "reports.dialog.police.title": "Transmitir à polícia · {reference}",
  "reports.dialog.police.body": "Registe a quem a denúncia foi transmitida. Nada é enviado a partir daqui.",
  "reports.dialog.share.title": "Dados entregues à polícia · {reference}",
  "reports.dialog.share.body":
    "Registe exatamente o que foi entregue, categoria a categoria. Este registo é guardado e consta do registo de auditoria.",
  "reports.dialog.hold.title": "Aplicar uma retenção legal · {reference}",
  "reports.dialog.hold.body":
    "Nada relacionado com esta denúncia poderá ser eliminado enquanto a retenção estiver em vigor, nem sequer pela regra de conservação.",
  "reports.dialog.release.title": "Levantar a retenção legal · {reference}",
  "reports.dialog.release.body": "As regras de conservação voltam a aplicar-se a tudo o que a retenção protegia.",

  "reports.field.evidence": "A prova",
  "reports.field.evidenceUrl": "Ligação (opcional)",
  "reports.field.evidenceUrlHint": "Um endereço https://, por exemplo uma foto carregada no processo.",
  "reports.field.severity": "Nova gravidade",
  "reports.field.verdict": "Veredicto",
  "reports.field.suspendedUntil": "Suspenso até",
  "reports.field.toldReason": "Motivo lido pela pessoa",
  "reports.field.toldHint": "Uma frase verdadeira, em palavras que a pessoa entenda. Pelo menos 10 caracteres.",
  "reports.field.decision": "Decisão",
  "reports.field.station": "Esquadra ou brigada",
  "reports.field.officerName": "Nome do agente",
  "reports.field.officerContact": "Contacto do agente (opcional)",
  "reports.field.policeReference": "Referência da polícia (opcional)",
  "reports.field.referral": "Transmissão",
  "reports.field.categories": "Dados entregues",
  "reports.field.shareDescription": "O que foi entregue, exatamente",
  "reports.field.shareDescriptionHint":
    "Por exemplo: mensagens de 3 a 5 de maio, digitalização do bilhete de identidade.",
  "reports.field.reasonOptional": "Motivo (opcional)",

  "reports.problem.reason": "Indique um motivo de {min} a {max} caracteres.",
  "reports.problem.told": "Escreva o motivo lido pela pessoa: pelo menos {min} caracteres.",
  "reports.problem.evidence": "Descreva a prova.",
  "reports.problem.url": "A ligação tem de ser um endereço http:// ou https:// completo.",
  "reports.problem.until": "Escolha uma data de fim de suspensão no futuro.",
  "reports.problem.police": "Indique a esquadra e o nome do agente (2 a 200 caracteres cada).",
  "reports.problem.referral": "Escolha a transmissão em causa.",
  "reports.problem.categories": "Assinale pelo menos uma categoria de dados entregues.",
  "reports.problem.shareDescription": "Diga exatamente o que foi entregue.",

  "reports.done.evidence": "Prova adicionada a {reference}.",
  "reports.done.severity": "Gravidade de {reference} alterada.",
  "reports.done.suspend": "Pessoa suspensa até decisão da equipa ({reference}). Foi avisada na aplicação.",
  "reports.done.lift": "Suspensão levantada ({reference}).",
  "reports.done.verdict": "Veredicto registado em {reference}. A pessoa foi avisada na aplicação.",
  "reports.done.ban": "Banimento registado em {reference}. A pessoa foi avisada na aplicação.",
  "reports.done.appeal": "Recurso decidido em {reference}. A pessoa foi avisada na aplicação.",
  "reports.done.police": "Transmissão à polícia registada em {reference}.",
  "reports.done.share": "Dados entregues registados em {reference}.",
  "reports.done.hold": "Retenção legal aplicada em {reference}.",
  "reports.done.release": "Retenção legal levantada em {reference}.",

  "reports.error.stale": "Esta denúncia mudou enquanto a consultava. Recarregue-a, verifique e tente novamente.",
  "reports.error.refused":
    "Ação recusada: as suas funções não incluem a funcionalidade necessária. Peça acesso a um responsável.",
  "reports.error.appealRefused":
    "Recusado: o recurso tem de ser decidido por alguém que não o autor do veredicto, com HANDLE_APPEALS.",
  "reports.error.shareRefused": "Recusado: só um proprietário pode entregar dados à polícia.",
  "reports.error.invalid":
    "Recusado: a denúncia já não está no estado esperado, ou um campo é inválido. Recarregue-a e verifique.",
  "reports.error.outcomeUnknown":
    "Sem resposta do servidor: a ação pode ter sido registada. Tente novamente: o mesmo clique não pode ser aplicado duas vezes.",

  "reports.refused.wrongStatus":
    "Recusado: esta denúncia já não está nessa etapa, a ação já não se aplica. Recarregue-a.",
  "reports.refused.alreadyRestricted": "Recusado: esta pessoa já está suspensa por outra denúncia.",
  "reports.refused.notSuspended": "Recusado: esta denúncia já não tem nenhuma suspensão em vigor. Recarregue-a.",
  "reports.refused.suspendedUntilRequired": "Uma suspensão temporária precisa de uma data de fim no futuro.",
  "reports.refused.ownVerdict":
    "Recusado: foi o autor deste veredicto, por isso outra pessoa tem de decidir o recurso.",
  "reports.refused.alreadyHeld": "Esta denúncia já está sob retenção legal. Recarregue-a.",
  "reports.refused.notHeld": "Esta denúncia já não está sob retenção legal. Recarregue-a.",
};
